import { z } from 'zod'
import { AvatarSchema } from './AvatarSchema'

export const PhotoSubscriberSchema = z.object({
  userFullName: z.string(),
  username: z.string(),
  userAvatar: AvatarSchema,
})
